export const extractLanguage = (pathname) => {
    if (pathname.startsWith('/en')) {
      return 'en';
    }
    return 'default';
  };

// Storyblok assets carry alt text on `alt`, but some only have it in `meta_data.alt`
export const getStoryblokAlt = (asset, fallback = '') => (
  asset?.alt || asset?.meta_data?.alt || fallback
);
